var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9A868"
    },
    points: "16,428 32,428 32,348 32,324 200,324 200,348 200,428 280,428 280,348 280,324 448,324  448,348 448,428 464,428 464,308 16,308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6805C"
    },
    points: "448,452 384,452 280,452 280,428 200,428 200,452 136,452 32,452 32,428 16,428 16,468  464,468 464,428 448,428  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6805C"
    },
    d: "M456,290.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5 h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5h-21 c-0.828,0-1.5-0.672-1.5-1.5c0,0.828-0.672,1.5-1.5,1.5H16v16h448v-16h-6.5C456.672,292,456,291.328,456,290.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF515A"
    },
    points: "192.999,169.159 192.825,169.159 186.599,187.492 199.226,187.492  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF515A"
    },
    d: "M239.87,175.155c0-4.663-3.07-7.501-8.08-7.501h-9.152v15.031h9.325 C236.974,182.685,239.87,179.933,239.87,175.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M48,220H24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M96,220H72v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF515A"
    },
    d: "M24,290.5V220h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5 c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220 h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21 c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5 c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220 h24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220h8v-74H96v-22.578c-2.614,0.374-5.283,0.578-8,0.578 s-5.386-0.204-8-0.578V146H16v74H3c-1.657,0-3,1.343-3,3v67.5c0,0.828,0.672,1.5,1.5,1.5H16h6.5C23.328,292,24,291.328,24,290.5z  M320.943,162.209h32.523v5.589h-13.003V204h-6.487v-36.201h-13.032V162.209z M290.201,162.209h26.529v5.589h-20.042v12.221h18.97 v5.387h-18.97v12.975h20.042V204h-26.529V162.209z M252.77,162.209h6.487v19.896h0.261l17.464-19.896h7.703l-16.566,18.506 L286.076,204h-8.051l-14.48-18.824l-4.287,4.894V204h-6.487V162.209z M216.151,162.209h16.421c8.601,0,13.959,4.981,13.959,12.772 c0,5.647-3.012,10.223-8.109,11.932L247.805,204h-7.501l-8.514-16.073h-9.152V204h-6.487V162.209z M189.466,162.209h7.009 L211.563,204h-6.864l-3.823-11.295h-15.929L181.125,204h-6.748L189.466,162.209z M127.511,162.209h7.501l13.525,32.986h0.231 l13.496-32.986h7.53V204h-5.937v-30.757h-0.203l-12.598,30.438h-4.807l-12.628-30.438h-0.202V204h-5.908V162.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M144,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M192,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M240,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M288,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M477,220h-13h-8v70.5c0,0.828,0.672,1.5,1.5,1.5h6.5h14.5c0.828,0,1.5-0.672,1.5-1.5V223 C480,221.343,478.657,220,477,220z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95FFFF"
    },
    points: "136,452 32,348 32,428 32,452  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95FFFF"
    },
    points: "384,452 280,348 280,428 280,452  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M336,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M384,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M432,220h-24v70.5c0,0.828,0.672,1.5,1.5,1.5h21c0.828,0,1.5-0.672,1.5-1.5V220z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 324,
    style: {
      fill: "#6EB1E2"
    },
    width: 168,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 324,
    style: {
      fill: "#6EB1E2"
    },
    width: 168,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#80D7F0"
    },
    points: "136,452 200,452 200,428 200,348 32,348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#80D7F0"
    },
    points: "384,452 448,452 448,428 448,348 280,348  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M96,123.422c27.137-3.883,48-27.211,48-55.422c0-30.928-25.072-56-56-56c-30.928,0-56,25.072-56,56 c0,28.211,20.863,51.539,48,55.422c2.614,0.374,5.283,0.578,8,0.578S93.386,123.796,96,123.422z M48,68c0-22.091,17.909-40,40-40 c22.091,0,40,17.909,40,40c0,22.091-17.909,40-40,40C65.909,108,48,90.091,48,68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128,68c0-22.091-17.909-40-40-40c-22.091,0-40,17.909-40,40c0,22.091,17.909,40,40,40 C110.091,108,128,90.091,128,68z M64,68c0-13.255,10.745-24,24-24s24,10.745,24,24s-10.745,24-24,24S64,81.255,64,68z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF515A"
    },
    cx: 88,
    cy: 68,
    r: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2D057"
    },
    points: "133.419,173.243 133.622,173.243 146.249,203.682 151.056,203.682 163.654,173.243  163.857,173.243 163.857,204 169.794,204 169.794,162.209 162.264,162.209 148.768,195.195 148.537,195.195 135.012,162.209  127.511,162.209 127.511,204 133.419,204  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M184.948,192.705h15.929L204.699,204h6.864l-15.089-41.791h-7.009L174.377,204h6.748 L184.948,192.705z M192.825,169.159h0.174l6.226,18.333h-12.627L192.825,169.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D057"
    },
    d: "M222.638,187.927h9.152L240.304,204h7.501l-9.384-17.087c5.097-1.709,8.109-6.285,8.109-11.932 c0-7.791-5.358-12.772-13.959-12.772h-16.421V204h6.487V187.927z M222.638,167.654h9.152c5.01,0,8.08,2.838,8.08,7.501 c0,4.778-2.896,7.53-7.906,7.53h-9.325V167.654z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2D057"
    },
    points: "259.258,190.07 263.544,185.176 278.025,204 286.076,204 268.12,180.715 284.685,162.209  276.982,162.209 259.518,182.105 259.258,182.105 259.258,162.209 252.77,162.209 252.77,204 259.258,204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2D057"
    },
    points: "316.729,198.382 296.688,198.382 296.688,185.407 315.657,185.407 315.657,180.02  296.688,180.02 296.688,167.799 316.729,167.799 316.729,162.209 290.201,162.209 290.201,204 316.729,204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2D057"
    },
    points: "333.975,204 340.462,204 340.462,167.799 353.466,167.799 353.466,162.209 320.943,162.209  320.943,167.799 333.975,167.799  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.94cdb0569dc3ecf7e603b12665948133.svg";
export { ForwardRef as ReactComponent };